module.exports = __webpack_public_path__ + "img/hero-slider-2.7716eade.jpg";